
export function showFiveSections() {
    if ($('.js-good-examples').find('.one-example').length > 0) {
        $('.one-example').last().after('<div class="selected-examples"></div>');
        const numSections = $('.one-example').length;
        const randomNum = Math.floor((Math.random() * numSections));
        const showMaxSections = (numSections > 5) ? 5 : numSections;
        for (let i = randomNum; i < randomNum + showMaxSections; i++) {
            $('.selected-examples').append($('.one-example').eq(i % numSections));
        }
    }
}
